module.exports = __webpack_public_path__ + "static/media/effort-box.9ef51e07.svg";